import Vue from 'vue';
import App from './App.vue';
import './registerServiceWorker';
import router from './router';
import store from './store';
import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import VueIziToast from 'vue-izitoast';
import 'izitoast/dist/css/iziToast.min.css';
import VueSweetalert2 from 'vue-sweetalert2';
// If you don't need the styles, do not connect
import 'sweetalert2/dist/sweetalert2.min.css';
import axios from 'axios';


// axios.defaults.baseURL = 'https://tranquil-bayou-87162.herokuapp.com';
// axios.defaults.baseURL = 'http://localhost:3000';
axios.defaults.baseURL = 'https://jscc-api.herokuapp.com';
axios.defaults.headers.post['Content-Type'] = 'application/json';
// axios.defaults.headers.common['Authorization'] = `Bearer ${userToken}`;
axios.interceptors.request.use((config) => config);
axios.interceptors.response.use((response) => response);

const options = {
  confirmButtonColor: '#0A2463',
  cancelButtonColor: '#ff7674',
};

Vue.use(DatePicker)
Vue.use(VueIziToast);
Vue.use(VueSweetalert2, options);
Vue.config.errorHandler = function(err, vm, info) {
  console.log(`Error: ${err.toString()}\nInfo: ${info}`);
}
Vue.config.warnHandler = function(msg, vm, trace) {
  console.log(`Warn: ${msg}\nTrace: ${trace}`);
}
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
